/* eslint-disable import/prefer-default-export */

export const FINANCIAL_CONNECTION_ACCOUNTS_CHANGED = 'FINANCIAL_CONNECTION_ACCOUNTS_CHANGED';
export const FINANCIAL_CONNECTION_ACCOUNT_DELETED = 'FINANCIAL_CONNECTION_ACCOUNT_DELETED';
